'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = alexaService;

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function alexaService(config, apiContext, applyReauth) {
  var apiEndpoint = config.domains.api + '/alexaskill';
  var alexaEndpoints = {
    status: 'status',
    link: 'link',
    urls: 'urls'
  };

  function getStatus() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint + '/' + alexaEndpoints.status,
      isAjax: false,
      disableRetry: true
    }, apiContext);
  }

  function getUrls() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: apiEndpoint + '/' + alexaEndpoints.urls,
      isAjax: false,
      disableRetry: true
    }, apiContext);
  }

  function linkAlexa(data) {
    return (0, _tuneInRequest2.default)({
      method: 'post',
      url: apiEndpoint + '/' + alexaEndpoints.link,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      isAjax: false,
      data: _qs2.default.stringify(data),
      disableRetry: true
    }, apiContext);
  }

  return {
    getStatus: applyReauth(getStatus),
    linkAlexa: applyReauth(linkAlexa),
    getUrls: getUrls
  };
}
//# sourceMappingURL=alexa.js.map